module.exports = __webpack_public_path__ + "img/PGR_A04_front_en.4f4774c4.png";